export default __webpack_public_path__ + "static/media/mediumDeskFill.358818fc.svg";